import { StyledText } from '@Components/Text/Text/styled';
import { TextProps } from '@Components/Text/Text/types';
import { InformationCircle } from '@Components/TextWithOverflow/styled';
import { useLayoutEffect, useRef, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function Text({
	text,
	children,
	size = 'medium',
	weight = 'medium',

	maxLines,

	...rest
}: TextProps) {
	const content = text || children;

	const textRef = useRef<HTMLParagraphElement>(null);

	const [showOverlay, setShowOverlay] = useState(false);

	useLayoutEffect(() => {
		if (!textRef.current) return;

		const handleResize = () => {
			const { scrollHeight, offsetHeight } = textRef.current!;
			setShowOverlay(scrollHeight > offsetHeight);
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<>
			<StyledText
				ref={textRef}
				size={size}
				weight={weight}
				maxLines={maxLines}
				{...rest}
			>
				{content}
			</StyledText>
			{showOverlay && maxLines && (
				<OverlayTrigger
					placement="top"
					overlay={<Tooltip id={'tooltip-bottom'}>{content}</Tooltip>}
				>
					<div
						style={{
							display: 'flex',
						}}
					>
						<InformationCircle
							style={{
								alignSelf: 'center',
							}}
						/>
					</div>
				</OverlayTrigger>
			)}
		</>
	);
}

export default Text;
